import React from "react";

import { sendLog } from "@/businessLogics/_common/logging";
import { BusinessInfo } from "@/components/organisms/Footer/BusinessInfo";

import * as S from "./Footer.style";

interface Props {
  footerNavItems: Array<any>; //Footer Nav 항목 구성요소
  footerSNSItems: Array<any>; //SNS 목록 구성요소
  footerInfoFirstLineItems: Array<any>; //문의&안내 첫째줄 구성요소
  footerInfoSecondLineItems: Array<any>; //문의&안내 둘째줄 구성요소
  infoDropDownText: string; //기업정보 드랍다운 텍스트
  infoDropDownIconImg: string; //기업정보 드랍다운 토클 아이콘 이미지
  businessInfoItems: Array<any>; //기업정보 배열
  copyRightText: string; //카피라이트 안내 텍스트
}

export const Footer = ({
  footerNavItems,
  footerSNSItems,
  footerInfoFirstLineItems,
  footerInfoSecondLineItems,
  infoDropDownText,
  infoDropDownIconImg,
  businessInfoItems,
  copyRightText,
}: Props) => {
  function handleClickFooter(buttonText: string) {
    sendLog("sw_footer_click", { button_text: buttonText });
  }

  return (
    <>
      <S.Footer>
        <S.FooterContentWrap>
          <S.FMenu>
            <S.FooterNavWrapper>
              <S.FooterLabel>SW캠프</S.FooterLabel>
              <S.FooterNav>
                {footerNavItems.map((item) => (
                  <S.FooterNavItemWrapper
                    key={item.text}
                    onClick={() => handleClickFooter(item.text)}
                  >
                    {!!item.href && item.href.charAt(0) === "/" ? (
                      <S.FooterNavItem
                        href={item.href}
                        isBold={item.text === "개인정보처리방침"}
                      >
                        {item.text}
                      </S.FooterNavItem>
                    ) : (
                      <S.FooterNavItem
                        target="_blank"
                        href={item.href}
                        isBold={item.text === "개인정보처리방침"}
                      >
                        {item.text}
                      </S.FooterNavItem>
                    )}
                  </S.FooterNavItemWrapper>
                ))}
              </S.FooterNav>
            </S.FooterNavWrapper>
            <S.FooterNavWrapper>
              <S.FooterLabel>ETC</S.FooterLabel>
              <S.FooterNav>
                {footerInfoFirstLineItems.map((item) => (
                  <S.FooterNavItemWrapper
                    key={item.text}
                    onClick={() => handleClickFooter(item.text)}
                  >
                    {!!item.href && item.href.charAt(0) === "/" ? (
                      <S.FooterNavItem
                        href={item.href}
                        isBold={item.text === "개인정보처리방침"}
                      >
                        {item.text}
                      </S.FooterNavItem>
                    ) : (
                      <S.FooterNavItem
                        target="_blank"
                        href={item.href}
                        isBold={item.text === "개인정보처리방침"}
                      >
                        {item.text}
                      </S.FooterNavItem>
                    )}
                  </S.FooterNavItemWrapper>
                ))}
              </S.FooterNav>
            </S.FooterNavWrapper>
            <S.FooterSNS>
              {footerSNSItems.map((item) => (
                <S.FooterSNSItem
                  key={item.text}
                  href={item.href}
                  target="_blank"
                  backgroundImg={`url(${item.img})`}
                >
                  {item.text}
                </S.FooterSNSItem>
              ))}
            </S.FooterSNS>
          </S.FMenu>
          <S.FooterLine />
          <S.Contacts>
            <S.ContactsLine>
              {footerInfoSecondLineItems.map((item) => (
                <S.ContactsLineItem key={item.href}>
                  <S.FooterNavItem
                    target="_blank"
                    href={item.href}
                    isBold={item.text === "개인정보처리방침"}
                  >
                    {item.text}
                  </S.FooterNavItem>
                </S.ContactsLineItem>
              ))}
            </S.ContactsLine>
          </S.Contacts>
          <S.BottomSectionWrapper>
            <BusinessInfo
              infoDropDownText={infoDropDownText}
              infoDropDownIconImg={infoDropDownIconImg}
              businessInfoItems={businessInfoItems}
            />
            <S.CopyRight>{copyRightText}</S.CopyRight>
          </S.BottomSectionWrapper>
        </S.FooterContentWrap>
      </S.Footer>
    </>
  );
};
